import script from "./attribution-data-access-authorization.vue?vue&type=script&setup=true&lang=js"
export * from "./attribution-data-access-authorization.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__